export default {
    it: {
       
    },
    en: {
       
    }
}